/* eslint-disable react/no-danger */
import React from 'react';
import { string, shape, number, func, object } from 'prop-types';
import { t } from 'i18next';
import cn from 'classnames';
import { ellipse } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';

import Card from '~components/Card';
import SelectTimeDispatch from '~screens/Dashboard/components/SelectTimeDispatch';

import styles from './styles.module.scss';

function StoreInfo({ deliveryInfo, className, onSelectedTime, selectedTime, setScheduled }) {
  const { open, name } = deliveryInfo;

  return (
    <Card
      className={cn('full-width', className, {
        [styles.storeInfoCard]: open,
        [styles.storeClosedInfoCard]: !open
      })}
      overrideClasses>
      <div className="column middle center full-width">
        <div className={cn('row middle space-between full-width', styles.addressInfoContainer)}>
          <span className={styles.address}>
            {t('DispatchDetails:storeFrom', {
              name,
              interpolation: { escapeValue: false }
            })}
          </span>
          <div
            className={cn('row middle', styles.storeStatusContainer, {
              [styles.storeStatusCloseContainer]: !open
            })}>
            <IonIcon
              className={cn(styles.iconCircle, {
                [styles.iconCircleClose]: !open
              })}
              icon={ellipse}
            />
            <span
              className={cn('m-right-1', styles.labelStoreStatus, {
                [styles.labelStoreStatusClose]: !open
              })}>
              {open ? t('DispatchDetails:storeOpen') : t('DispatchDetails:storeClosed')}
            </span>
          </div>
        </div>
        <SelectTimeDispatch
          onSelectedTime={onSelectedTime}
          selectedDeliveryTime={selectedTime}
          setScheduled={setScheduled}
        />
      </div>
    </Card>
  );
}
StoreInfo.propTypes = {
  className: string,
  deliveryInfo: shape({
    deliveryWaitTime: number
  }),
  selectedTime: object,
  setScheduled: func,
  onSelectedTime: func
};
export default StoreInfo;
